import RegisteredCUPSWidget from './RegisteredCUPSWidget';

export default RegisteredCUPSWidget;
